function txtCopy(target: HTMLInputElement) {
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    target.readOnly = false;
    const range = document.createRange();
    range.selectNode(target);
    (window as any).getSelection().addRange(range);
    (document as any).execCommand('copy');
    target.readOnly = true;
  } else {
    target.select();
    (document as any).execCommand('copy');
  }
  alert("コピーしました");
}

document.addEventListener("click", (event)=>{
  if ((event as any).target.closest(".js-input-copy")) {
    const copyTarget = (event as any).target.closest(".c-label__style").querySelector(".c-input--normal");
    txtCopy(copyTarget);
  }
})
